import React from "react";
import { Tag } from "antd";
import { GiftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const BusinessTagGift: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Tag icon={<GiftOutlined />} color="purple">
      {t("business.tags.giftCards")}
    </Tag>
  );
};

export default BusinessTagGift;
